module.exports = __webpack_public_path__ + "img/special_battleRoyale.60a2166d.png";